var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1 13.8281H15.8987C9.71158 13.8281 6.61799 13.8281 4.88026 15.6373C3.14254 17.4465 3.5514 20.2416 4.36912 25.8319L5.14456 31.1331C5.78582 35.5171 6.10646 37.709 7.7513 39.0217C9.39615 40.3344 11.8221 40.3344 16.6741 40.3344H27.3245C32.1765 40.3344 34.6026 40.3344 36.2474 39.0217C37.8923 37.709 38.2129 35.5171 38.8541 31.1331L39.6296 25.8319C40.4473 20.2417 40.8561 17.4465 39.1184 15.6373C37.3807 13.8281 34.2871 13.8281 28.1 13.8281ZM26.7316 28.9571C27.7553 28.3225 27.7553 26.6796 26.7316 26.045L20.5503 22.2131C19.5554 21.5963 18.3327 22.3991 18.3327 23.6691V31.333C18.3327 32.603 19.5554 33.4058 20.5503 32.789L26.7316 28.9571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.601 3.66408H28.3979C28.8241 3.66397 29.1509 3.66389 29.4365 3.69183C31.4675 3.89051 33.1299 5.11163 33.8348 6.75648H10.1641C10.869 5.11163 12.5314 3.89051 14.5624 3.69183C14.848 3.66389 15.1748 3.66397 15.601 3.66408Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.5689 8.65625C9.01939 8.65625 6.9289 10.1958 6.23127 12.2382C6.21672 12.2808 6.20278 12.3236 6.18945 12.3666C6.91939 12.1455 7.67906 12.0011 8.44809 11.9025C10.4288 11.6486 12.9319 11.6487 15.8396 11.6489H28.4751C31.3829 11.6487 33.886 11.6486 35.8667 11.9025C36.6357 12.0011 37.3954 12.1455 38.1253 12.3666C38.112 12.3236 38.098 12.2808 38.0835 12.2382C37.3858 10.1958 35.2954 8.65625 32.7459 8.65625H11.5689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoProgressIcon);
export default __webpack_public_path__ + "static/media/video_progress_icon.210f449a38dacbf260a2c842775cf1ea.svg";
export { ForwardRef as ReactComponent };